export const initOrderRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/orders",
          name: "order",
          component: () => import("@/pages/manage/orders/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [
              config.roles.administrators,
              config.roles.siteEditors,
              config.roles.customerService,
            ],
          },
        },
        {
          path: "/manage/orders/:id",
          name: "order-id",
          component: () => import("@/pages/manage/orders/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [
              config.roles.administrators,
              config.roles.siteEditors,
              config.roles.customerService,
            ],
          },
        },
      ];
